export const MIN_WIDTH = 120;
export const MAX_WIDTH = 270;

export const BUTTON_CLASS = {
  SUBMIT: 'submit',
  BLUE: 'blue',
  YELLOW: 'yellow',
  CANCEL: 'cancel',
  DARK_BLUE: 'dark-blue',
  DEFAULT: 'default'
};